"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function getDomain() {
    var domain = null;
    if (window.location.hostname) {
        var parts = [];
        if (window.location.hostname.indexOf(".") > 0) {
            parts = window.location.hostname.split(".").reverse();
        } else {
            parts = [window.location.hostname];
        }
        if (parts.length >= 2) {
            domain = parts[1] + "." + parts[0];
        } else {
            domain = parts[0];
        }
    }
    return domain;
}

exports.default = getDomain;